<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"></a><span class="f1">FIGHTER PILOT</span>: FROM COLD WAR JETS TO <span class="f2">SPITFIRES</span></h1>
<p class="subtitle">THE EXTRAORDINARY MEMOIRS OF A BATTLE OF BRITAIN MEMORIAL FLIGHT PILOT</p>
<p class="author"><span class="bold">CHRISTOPHER COVILLE</span></p>
<div class="image_container">
<img alt="Image" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?4a37635c